import { Brand } from "../../lib/brands";

export const getHelpCenterHref = (brand: Brand): string => {
  const elemezHelpCenterURL = "https://elemezresourcecentre.b2msolutions.com";

  const helpCenterURLs: Record<string, string> = {
    panasonic: "https://smartessentialshelpcentre.b2msolutions.com",
    brady: "https://bradyhelpcentre.b2msolutions.com"
  };

  return helpCenterURLs[brand] || elemezHelpCenterURL;
};
